import { useEffect, useState } from 'react';
import Subtitle from 'components/Subtitle';
import Loader from 'components/SectionLoader';
import { Box } from '@mui/material';
import Button from 'components/Button';
import { useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearOrganizationSelectedMobileDevice, setOrganizationSelectedMobileDevice } from 'features/organizationSlice';
import { fetchAdminMobileDevices } from 'api/portal';
import { showErrorToast } from 'features/toastSlice';
import MobileDeviceDetails from 'components/MobileDeviceDetails';
import StatusSetupDialog from 'components/dialogs/StatusSetupDialog';
import Fade from 'components/Fade';
import App from '../template';

function AdminMobileDeviceInfo() {
  const mobileDevice = useSelector((state) => state.organization.selectedMobileDevice);

  const [isLoadingDevice, setIsLoadingDevice] = useState(true);
  const [showDialog, setShowDialog] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = useParams();

  const { t } = useTranslation();

  const { orgId, deviceId } = params;

  const onErrorFetchingDevice = () => {
    dispatch(showErrorToast('organization.organization-mobile-devices-edit.error-fetch-device'));
    navigate('/braincare/admin-mobile-devices');
  };

  useEffect(() => {
    if (mobileDevice.org_device_id !== deviceId) {
      dispatch(clearOrganizationSelectedMobileDevice());
    }

    fetchAdminMobileDevices(new URLSearchParams(), {
      org_device_id: deviceId, organization_id: orgId
    })
      .then((response) => {
        const { data } = response;

        if (!data.results) {
          onErrorFetchingDevice();
        } else {
          const device = data.results[0];

          dispatch(clearOrganizationSelectedMobileDevice());
          dispatch(setOrganizationSelectedMobileDevice(device));
          setIsLoadingDevice(false);
        }
      })
      .catch(() => {
        onErrorFetchingDevice();
      });
  }, []);

  return (
    <App device={mobileDevice}>
      <Subtitle>{t('organization.organization-mobile-devices-info.title-info-device')}</Subtitle>
      <Loader loading={isLoadingDevice}>
        <Fade>
          <Box maxWidth="428px" marginBottom="48px">
            <MobileDeviceDetails device={mobileDevice} />
            <Button color="gradient" onClick={() => setShowDialog(true)} data-testid="change-status-button">
              {t('organization.organization-mobile-devices-info.logdialog.change-trust-status-button')}
            </Button>
          </Box>
        </Fade>
      </Loader>
      <Button
        sx={{ margin: '0 0 0 16px' }}
        variant="outlined"
        onClick={() => {
          navigate('/braincare/admin-mobile-devices');
        }}
        data-testid="cancel-button"
      >
        {t('organization.organization-members-edit.button-cancel')}
      </Button>
      <StatusSetupDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        excludeStatus={mobileDevice.status}
        onConfirm={(status) => {
          /* eslint-disable-next-line max-len */
          navigate(`/braincare/admin-mobile-devices/${mobileDevice.organization_id}/${mobileDevice.org_device_id}/edit-status?status=${status}`);
        }}
        data-testid="choose-status-dialog"
      />
    </App>
  );
}

export default AdminMobileDeviceInfo;
